import CustomButton from 'components/CustomInput/Button';
import TextHeader from 'components/CustomText/TextHeader';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import CancelIcon from '@material-ui/icons/Cancel';
import useQuery from 'hooks/useQuery';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components/macro';
import CustomTextField from '../../Input/CustomTextField';
import AmendmentItem from './AmendmentItem';
import api from 'api/call';
import LoadingIndicator from 'components/LoadingIndicator';
import { getTimeWithTimeZone, subscribe } from 'utility/general';
import { useSelector } from 'react-redux';
import UploadWrapper from 'components/UploadWrapper';
import { useHistory } from 'react-router';
import _ from 'lodash';
import useDialog from 'components/ConfirmDialog/useDialog';
import {
    AMENDMENT_CONFIRM_RE_SUBMIT_TIPS,
    AMENDMENT_CONFIRM_SUBMIT_TIPS,
    AMENDMENT_FORM_CHANGE_UPLOAD,
    AMENDMENT_NOT_EXIST,
    AMENDMENT_SUBMIT_SUCCESS,
    AMENDMENT_SUBMIT_TIPS,
    CHECK_SITE_SEND,
    COMPLETE_BEFORE_AMENDMENT_SUBMIT,
    CONFIRM_TO_LEAVE_AMENDMENT,
    CONFIRM_TO_SAVE_AMENDMENT_FORM,
    DATE_NOT_VALID,
    DATE_NOT_VALID_BEFORE_SUBMIT,
    DOWNLOAD_AMENDMENT_FORM,
    SAVE_AMENDMENT_SUCCESS,
} from 'utility/frontendMessage';
import { cloneDeep } from 'lodash';
import { APPLICANT, DRAFT, RETURNED } from 'utility/lookup';
import { useDispatch } from 'react-redux';
import { GET_DOWNLOAD_DOCUMENT } from 'store/key';
import { setGlobalLoading } from 'store/global/reducer';
import useCommentDialog from 'components/CommentDialog/useCommentDialog';
import { SHyperLink } from 'style/CommonStyledComponent';

const SLayout = styled.div`
    width: 100%;
    position: relative;
    height: 100%;
`;

const SCancelIcon = styled(CancelIcon)`
    width: 20px;
    height: 20px;
    cursor: pointer;
`;

const SContent = styled.div`
    position: absolute;
    top: ${(props) => (props.isEdit ? '50px' : '0px')};
    left: 0;
    right: 0;
    bottom: 0;
    padding: 15px;
    overflow-y: auto;
`;

const SBackgroundInfoLayout = styled.div`
    margin-top: 10px;
`;

const SStudyTitle = styled.div`
    width: 100%;
    margin-top: 20px;
`;

const SDetailInfoLayout = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

const SDetailItemLayout = styled.div`
    width: 48%;
    margin-top: 20px;
`;

const STableLayout = styled.div`
    margin-top: 20px;
`;

const SHeaderAction = styled.div`
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    background: #dcdcdc;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
`;

const SDummy = styled.div``;

const AmendmentForm = (props) => {
    const formId = useQuery('id');
    const [actualStartDate, setActualStartDate] = useState(null);
    const detail = useSelector((state) => state.applicationDetail);
    const applicationDetail = detail[formId];
    const [isLoading, setLoading] = useState(true);
    const [isError, setError] = useState(false);
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const showCommentDialog = useCommentDialog();
    const [isEditDateValid, setEditDateValid] = useState(false);
    const [isLocalUpload, setLocalUpload] = useState(false);
    const [uploadTempId, setUploadTempId] = useState(null);
    const [fileId, setFileId] = useState(null);
    const [hasChange, setHasChange] = useState(false);
    const [hasFileRemoved, setHasFileRemoved] = useState(false);
    const [fileUpload, setFileUpload] = useState({ fileName: '' });
    const [data, setData] = useState({});
    const showDialog = useDialog();
    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);
    const history = useHistory();
    const postData = useRef({});
    const validation = useRef({});

    const [isDownloading, setDownloading] = useState(false);

    const noAmendDataExist = user.role === APPLICANT && data.create;

    useEffect(() => {
        props?.updateHasChange(hasChange);
    }, [hasChange]);

    useEffect(() => {
        // if the component is destroyed, notify the parent
        return () => {
            props.updateHasChange(false);
        };
    }, []);

    const listOfDetails = [
        { key: 'refNo', display: 'IRB/REC Ref. No.', value: data?.amendmentForm?.refNo, disabled: true },
        { key: '', display: 'Actual Study Start Date', value: null, disabled: true, type: 'date' },
        { key: '', display: 'Protocol no.', value: data?.amendmentForm?.protocolNo, disabled: true },
        {
            key: '',
            display: 'Anticipated Study End Date',
            value: data?.amendmentForm?.anticipatedStudyEndDate
                ? getTimeWithTimeZone(data?.amendmentForm?.anticipatedStudyEndDate).format('YYYY-MM-DD')
                : '-',
            disabled: true,
        },
        { key: 'pi', display: 'Coordinating Investigator', value: data?.amendmentForm?.leadPi, disabled: true },
    ];

    useEffect(() => {
        const unsubscribe = subscribe('downloadSignedAmendment', () => {
            if (!data.fileId) {
                return showDialog({
                    disableCancelButton: true,
                    description: AMENDMENT_FORM_CHANGE_UPLOAD,
                });
            }

            setGlobalLoading(true);
            downloadSignedAmendmentForm();
        });

        return () => {
            unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        setLoading(true);
        setError(false);

        api.amendment
            .getAmendmentForm(formId)
            .then((res) => {
                const sorted = _.sortBy(res.data.result.details, (obj) => {
                    let oFieldName = obj.fieldName;
                    let data = oFieldName.substring(0, 2);

                    if (!data.endsWith('.')) {
                        oFieldName = ';' + oFieldName;
                    }

                    return oFieldName;
                });

                res.data.result.details = sorted;
                setData(res.data.result);

                setActualStartDate(res.data.result.amendmentForm.actualStudyStartDate);
                if (res.data.result.fileId) {
                    setFileUpload({
                        fileName: res.data.result.fileName,
                        key: res.data.result.fileId,
                    });
                }
            })
            .catch((err) => {
                setError(true);
            })
            .finally(() => {
                setLoading(false);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const convertType = (key) => {
        if (key === 'STUDY_INFO') {
            return 'Study Info';
        } else if (key === 'SITE_INFO') {
            return 'Site Info';
        } else {
            return key;
        }
    };

    const mergePostDataWithDetail = () => {
        const requestData = postData.current;
        const result = cloneDeep(data.details);

        Object.entries(requestData).forEach(([index, value]) => {
            const currentIndex = index - 1;
            result[currentIndex].increaseRisk = value.increaseRisk;
            result[currentIndex].proposedBy = value.proposedBy;
            result[currentIndex].reasonForChanges = value.reasonForChanges;
            result[currentIndex].type = convertType(value.type);
            result[currentIndex].formKey = value.formKey;
            delete result[currentIndex]['updateDtm'];
        });

        return result;
    };

    const checkPostDataValidation = () => {
        return Object.values(validation.current).every((item) => item);
    };

    const onDataUpdate = (id, data) => {
        if (!hasChange) {
            setHasChange(true);
        }

        postData.current[id] = data;
    };

    const onFileUploadFinish = (list) => {
        setFileUpload(list[0]);
        setLocalUpload(true);
        setUploadTempId(list[0].key);
        setHasFileRemoved(false);
    };

    const downloadAmendmentForm = async () => {
        setForceErrorDisplay(true);

        // check if compare detail exist
        if (getAmendmentData().length === 0) {
            return showDialog({
                description: AMENDMENT_NOT_EXIST,
                disableCancelButton: true,
            });
        }

        if (!isEditDateValid || !actualStartDate) {
            return showDialog({
                description: DATE_NOT_VALID,
                disableCancelButton: true,
            });
        }

        const isValid = checkPostDataValidation();

        if (!isValid) {
            return showDialog({
                description: DOWNLOAD_AMENDMENT_FORM,
                disableCancelButton: true,
            });
        }

        const details = mergePostDataWithDetail();

        setDownloading(true);

        api.amendment.downloadAmendmentForm(formId, new Date(actualStartDate), details, fileUpload?.key).finally(() => {
            setDownloading(false);
        });
    };

    const saveAmendmentForm = () => {
        const details = mergePostDataWithDetail();

        setGlobalLoading(true);

        api.amendment
            .saveAmendmentForm({
                formId,
                actualStudyStartDate: actualStartDate ? new Date(actualStartDate) : null,
                listOfAmendment: details,
                uploadTempId: uploadTempId ?? fileUpload?.key ?? null,
            })
            .then((res) => {
                if (res !== undefined) {
                    showDialog({
                        description: SAVE_AMENDMENT_SUCCESS,
                        disableCancelButton: true,
                    });
                }
                setLocalUpload(false);
                setUploadTempId(null);
                setFileId(uploadTempId ?? fileUpload?.key ?? null);
                setHasChange(false);
            })
            .finally(() => {
                setGlobalLoading(false);
            });
    };

    const amendmentFormCreate = (reSubmitComment) => {
        const details = mergePostDataWithDetail();

        setGlobalLoading(true);
        setForceErrorDisplay(true);

        api.amendment
            .submitAmendmentForm({
                formId,
                actualStudyStartDate: new Date(actualStartDate),
                listOfAmendment: details,
                uploadTempId: uploadTempId ?? fileUpload?.key ?? null,
                reSubmitComment,
            })
            .then((res) => {

                if( res !== undefined) {
                    setLocalUpload(false);
                    showDialog({
                        description: AMENDMENT_SUBMIT_SUCCESS,
                        disableCancelButton: true,
                    });
                    history.push(`/`);
                }

            })
            .finally(() => {
                setGlobalLoading(false);
            });
    };

    const getSubmitButtonDisabled = () => {
        if (hasFileRemoved) {
            return true;
        }

        if (data.fileId) {
            return false;
        }

        if (isEditStatus()) {
            return !fileUpload.fileName;
        } else {
            return true;
        }
    };

    const shouldAmendButtonShow = () => {
        return (noAmendDataExist && user.role === APPLICANT) || user.role === APPLICANT;
    };

    // need to check if user has permission to edit the form
    const isEditStatus = () => {
        // if not applicant, not the edit status
        if (user.role !== APPLICANT) {
            return false;
        }

        // for draft case, only viewed by for creator, it must be editable
        if (applicationDetail.status.statusId === DRAFT) {
            return true;
        }

        if (applicationDetail.status.statusId === RETURNED) {
            // should be "{site name}" or "Study Info"
            const amendInstitution = applicationDetail.applicationForm.amendInstitution;

            if (amendInstitution === 'Study Info') {
                // case of study info amendment
                if (applicationDetail.historyCi.toLowerCase() === user.detail.email.toLowerCase()) {
                    return true;
                }

                let isCIDelegation = false;

                applicationDetail.ciDelegation.forEach((item) => {
                    if (item.email.toLowerCase() === user.detail.email.toLowerCase()) {
                        isCIDelegation = true;
                    }
                });

                return isCIDelegation;
            } else {
                // case of site info amendment
                const listOfAllPIs = [...applicationDetail.pi, ...applicationDetail.piDelegation].filter((item) => {
                    return item.siteInfo.institution === amendInstitution;
                });

                let isPI = false;

                listOfAllPIs.forEach((item) => {
                    if (item.email.toLowerCase() === user.detail.email.toLowerCase()) {
                        isPI = true;
                    }
                });

                return isPI;
            }
        }

        return false;

        // return applicationDetail.status.statusId === RETURNED;
    };

    const getAmendmentData = () => {
        if (user.role === APPLICANT) {
            return data?.details;
        }

        // else if (user.role !== APPLICANT && data.create) {
        //     // data.create === true, means no data exist in server
        //     return [];
        // }

        return data?.details ?? [];
    };

    const downloadSignedAmendmentForm = () => {
        dispatch({
            type: GET_DOWNLOAD_DOCUMENT,
            payload: {
                data: {
                    id: fileId ?? data.fileId,
                    type: 'temp',
                },
                final: () => {
                    setGlobalLoading(false);
                },
            },
        });
    };

    const DisplayWrapper = isLocalUpload ? SDummy : SHyperLink;

    const getDownloadDocLayout = (tag) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {fileUpload.fileName ? 'Signed Document:' : ''}
                <div style={{ marginLeft: 8 }}>
                    <DisplayWrapper
                        onClick={() => {
                            if (!isLocalUpload) {
                                downloadSignedAmendmentForm();
                            }
                        }}
                    >
                        {fileUpload.fileName}
                    </DisplayWrapper>
                </div>
            </div>
        );
    };

    return (
        <SLayout className={'clearText'}>
            {isLoading ? (
                <div
                    style={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <LoadingIndicator />
                </div>
            ) : (
                <>
                    {shouldAmendButtonShow() && (
                        <>
                            <SHeaderAction>
                                <CustomButton
                                    style={{ marginRight: 15 }}
                                    type={'cancel'}
                                    onClick={async () => {
                                        let isConfirm = true;

                                        if (hasChange) {
                                            isConfirm = await showDialog({
                                                description: CONFIRM_TO_LEAVE_AMENDMENT,
                                            });
                                        }

                                        if (isConfirm) {
                                            props.backToStudyInfo();
                                        }
                                    }}
                                >
                                    Back to study info
                                </CustomButton>

                                {
                                    // case of showing download link for edit status
                                    user.role === APPLICANT &&
                                        !(
                                            applicationDetail.status.statusId === DRAFT ||
                                            applicationDetail.status.statusId === RETURNED
                                        ) &&
                                        getDownloadDocLayout(1)
                                }

                                {
                                    // case of showing download link for non-edit status of view only applicant, draft status is hidden for view only applicant
                                    !isEditStatus() &&
                                        applicationDetail.status.statusId === RETURNED &&
                                        getDownloadDocLayout(2)
                                }
                                {isEditStatus() && (
                                    <CustomButton
                                        style={{ marginRight: 15 }}
                                        onClick={async () => {
                                            const isConfirm = await showDialog({
                                                description: CONFIRM_TO_SAVE_AMENDMENT_FORM,
                                            });

                                            if (isConfirm) {
                                                saveAmendmentForm();
                                            }
                                        }}
                                    >
                                        Save
                                    </CustomButton>
                                )}

                                {isEditStatus() && (
                                    <CustomButton
                                        disabled={getSubmitButtonDisabled()}
                                        showToolTipInDisabledOnly
                                        style={{ marginRight: 15 }}
                                        tooltip={AMENDMENT_SUBMIT_TIPS}
                                        onClick={async () => {
                                            if (!actualStartDate) {
                                                setForceErrorDisplay(true);
                                                return showDialog({
                                                    description: DATE_NOT_VALID_BEFORE_SUBMIT,
                                                    disableCancelButton: true,
                                                });
                                            }

                                            const isAllSitePass = applicationDetail.siteInfo.every((item) => {
                                                return item.status === 1;
                                            });

                                            if (!isAllSitePass) {
                                                setForceErrorDisplay(true);
                                                return await showDialog({
                                                    description: CHECK_SITE_SEND,
                                                    disableCancelButton: true,
                                                });
                                            }

                                            // check all form has filled
                                            const isValid = checkPostDataValidation();

                                            if (!isValid) {
                                                setForceErrorDisplay(true);
                                                return showDialog({
                                                    description: COMPLETE_BEFORE_AMENDMENT_SUBMIT,
                                                    disableCancelButton: true,
                                                });
                                            }

                                            let isConfirm;
                                            let reSubmitComment;

                                            // case of submit
                                            if (applicationDetail.status.statusId === DRAFT) {
                                                isConfirm = await showDialog({
                                                    description:
                                                        applicationDetail.status.statusId === DRAFT
                                                            ? AMENDMENT_CONFIRM_SUBMIT_TIPS
                                                            : AMENDMENT_CONFIRM_RE_SUBMIT_TIPS,
                                                });
                                            } else {
                                                // case of re-submit
                                                const { submit, comment } = await showCommentDialog({
                                                    description: AMENDMENT_CONFIRM_RE_SUBMIT_TIPS,
                                                    placeholder: 'Leave your comments (if any)',
                                                    isRequired: false,
                                                });

                                                isConfirm = submit;
                                                reSubmitComment = comment;
                                            }

                                            if (isConfirm) {
                                                amendmentFormCreate(reSubmitComment);
                                            }
                                        }}
                                    >
                                        {applicationDetail.status.statusId === DRAFT ? 'Submit' : 'Re-Submit'}
                                    </CustomButton>
                                )}

                                {isEditStatus() && (
                                    <>
                                        <CustomButton
                                            style={{ marginRight: 15 }}
                                            loading={isDownloading}
                                            onClick={downloadAmendmentForm}
                                        >
                                            Download amendment form
                                        </CustomButton>
                                        <div style={{ marginRight: 15, display: 'flex' }}>
                                            <div style={{ marginRight: 8 }}>
                                                <UploadWrapper
                                                    disabled={getAmendmentData().length === 0}
                                                    multiple={false}
                                                    buttonText={'Upload signed document'}
                                                    onFileUploadFinish={onFileUploadFinish}
                                                />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                {fileUpload.fileName ? 'Signed Document:' : ''}
                                                <div style={{ marginLeft: 8 }}>
                                                    <DisplayWrapper
                                                        onClick={() => {
                                                            if (!isLocalUpload) {
                                                                downloadSignedAmendmentForm();
                                                            }
                                                        }}
                                                    >
                                                        {fileUpload.fileName}
                                                    </DisplayWrapper>
                                                </div>
                                                {/* {fileUpload?.key && (
                                                    <SCancelIcon
                                                        style={{ marginLeft: 10 }}
                                                        onClick={() => {
                                                            setHasFileRemoved(true);
                                                            setFileUpload({});
                                                        }}
                                                    />
                                                )} */}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </SHeaderAction>
                        </>
                    )}

                    <SContent isEdit={shouldAmendButtonShow()}>
                        <TextHeader underline>Amendments and Changes Application Form</TextHeader>
                        <TextSubHeader style={{ marginTop: 15 }}>1. Background information</TextSubHeader>
                        <SBackgroundInfoLayout>
                            <SStudyTitle>
                                <CustomTextField
                                    label={'Study Title'}
                                    value={data?.amendmentForm?.studyTitle}
                                    disabled
                                />
                            </SStudyTitle>

                            <SDetailInfoLayout>
                                {listOfDetails.map((item, index) => {
                                    if (item.type === 'date') {
                                        return (
                                            <SDetailItemLayout key={item.display}>
                                                <CustomDatePicker
                                                    label={item.display}
                                                    value={actualStartDate}
                                                    disabled={!noAmendDataExist || !isEditStatus()}
                                                    isValidValue={(isValid) => {
                                                        setEditDateValid(isValid);
                                                    }}
                                                    forceErrorDisplay={forceErrorDisplay}
                                                    validators={['isRequired']}
                                                    // hiddenValidationTips={!noAmendDataExist}
                                                    maxDate={
                                                        isEditStatus()
                                                            ? new Date(
                                                                  data?.amendmentForm?.anticipatedStudyEndDate,
                                                              ).getTime() -
                                                              1000 * 60 * 60 * 24
                                                            : undefined
                                                    }
                                                    onChange={(date) => {
                                                        setHasChange(true);
                                                        setActualStartDate(date.getTime());
                                                    }}
                                                />
                                            </SDetailItemLayout>
                                        );
                                    }

                                    return (
                                        <SDetailItemLayout key={item.display}>
                                            <CustomTextField
                                                label={item.display}
                                                value={item.value}
                                                disabled={item.disabled}
                                            />
                                        </SDetailItemLayout>
                                    );
                                })}
                            </SDetailInfoLayout>
                        </SBackgroundInfoLayout>
                        <TextSubHeader style={{ marginTop: 15 }}>
                            2. Proposed Amendments (Append new document with track changes)
                        </TextSubHeader>
                        <STableLayout>
                            {getAmendmentData()?.map((item, index) => {
                                return (
                                    <div key={noAmendDataExist ? index : item.id} style={{ marginBottom: 15 }}>
                                        <AmendmentItem
                                            data={item}
                                            index={index + 1}
                                            applicationDetail={applicationDetail}
                                            forceErrorDisplay={forceErrorDisplay}
                                            hasPermission={isEditStatus()}
                                            isAmendmentCreated={!noAmendDataExist}
                                            onValid={(isValid) => {
                                                validation.current[index + 1] = isValid;
                                            }}
                                            onDataUpdate={onDataUpdate}
                                        />
                                    </div>
                                );
                            })}
                            {getAmendmentData()?.length === 0 && (
                                <div>No Change is applied to the application amendment yet.</div>
                            )}
                        </STableLayout>
                    </SContent>
                </>
            )}
        </SLayout>
    );
};

export default AmendmentForm;
